var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9453 0 0 1.9453 740.0389 498.4871)",
    id: 794911
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "current",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-154.018, -256.005)",
    d: "M 288 439.6 l -130.9 68.7 C 152.2 510.8 147.1 512 142.2 512 c -18.59 0 -35.17 -16.66 -31.61 -37.45 l 25.04 -145.5 L 29.72 226.1 C 10.68 207.6 21.2 175.3 47.47 171.5 l 146.4 -21.29 l 65.43 -132.4 c 5.883 -11.91 17.33 -17.8 28.73 -17.8 c 0.0234 0 -0.0234 0 0 0 L 288 439.6 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftStar);
export default __webpack_public_path__ + "static/media/leftStar.316847bc3682eeea383bd5485caeaea1.svg";
export { ForwardRef as ReactComponent };